<template>
  <div>
    <b-form @submit.prevent="sendFilteredQuery">
      <b-row>
          <!--CREATED DATE RANGE-->
          <b-form-group
            id="created-group"
            :invalid-feedback="invalidCreatedDate"
            :state="stateCreatedDate"
            class="ml-3"
            label-for="created"
          >
            <VueCtkDateTimePicker
              id="created"
              :custom-shortcuts="defaultDatepickerShortcuts"
              v-model="filterModels.dateRange"
              :max-date="maxDate"
              :no-clear-button="true"
              :error="!stateCreatedDate"
              @is-hidden="applyDateRange"
              :autoClose="true"
              @validate="sendFilteredQuery"
              :hint="$t('pages.customer_payment_report.date_hint')"
              :locale="$_languageCode"
              :format="dateFormat"
              :formatted="dateFormat"
              outputFormat="YYYY-MM-DDTHH:mmZ"
              :range="true"
            >
            </VueCtkDateTimePicker>
          </b-form-group>
          <b-button
            class="bootstrap-input-height ml-3 mb-1"
            @click="clearAllFilters"
            :disabled="loading"
            variant="primary">
            <b-icon icon="arrow-repeat"></b-icon>
            {{ $t('filter.reset_button') }}
          </b-button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import moment from 'moment'
  import {DEFAULT_DATEPICKER_SHORTCUTS, getDateFormat} from '@base/configs'
  import {mapState} from "vuex";

  const defaultFilterModels = {
    dateRange: {
      start: moment().startOf('month').format('YYYY-MM-DD'),
      end: moment().startOf('day').format('YYYY-MM-DD')
    },
  }
  
  export default {
    name: 'PaymentReportFilter',

    data () {
      return {
        defaultDatepickerShortcuts: DEFAULT_DATEPICKER_SHORTCUTS,
        filterModels: {
          ...defaultFilterModels,
        },
        invalidCreatedDate: null,
        loading: false,
      }
    },

    watch: {
      'filterModels.dateRange'() {
        this.invalidCreatedDate = null
      }
    },

    computed: {
      ...mapState(['userMarket']),

      dateFormat() {
        return getDateFormat(this.userMarket?.supportCountry?.code)
      },

      maxDate () {
        return moment().format('YYYY-MM-DD')
      },

      filterArgs () {
        const startDate = moment.parseZone(this.filterModels.dateRange.start).format('YYYY-MM-DD')
        const endDate = moment.parseZone(this.filterModels.dateRange.end).format('YYYY-MM-DD')

        return {
          startDate: startDate,
          endDate: moment(endDate).add(1, 'days').format('YYYY-MM-DD'),
        }
      },

      isSaleDateValid () {
        if (!this.filterModels.dateRange)
          return false
        return !!this.filterModels.dateRange.start || !!this.filterModels.dateRange.end
      },
      stateCreatedDate () {
        return (this.invalidCreatedDate === null)
      },
    },

    created() {
      this.sendFilteredQuery()
    },

    methods: {
      applyDateRange () {
        this.$nextTick(this.sendFilteredQuery)
      },

      clearAllFilters () {
        this.loading = true
        this.filterModels = { ...defaultFilterModels }
        this.$store.commit(this.$_mutationTypes.SET_PAYMENT_REPORTS_FILTERS, this.filterArgs)
        this.$emit('filter-applied')
        this.loading = false
      },

      sendFilteredQuery () {
        if (!this.isSaleDateValid) {
          this.invalidCreatedDate = this.$t('validation.date_range')
          return
        }
        this.$store.commit(this.$_mutationTypes.SET_PAYMENT_REPORTS_FILTERS, this.filterArgs)
        this.$emit('filter-applied')
      },
    }
  }
</script>

<style scoped>

  #verified-group {
    width: 250px;
  }
</style>
